import debutant from '../styles/images/poussette.png';
import apprenti from '../styles/images/moto.png';
import amateur from '../styles/images/ferrari.png';
import confirme from '../styles/images/starship.png';
import expert from '../styles/images/armour.png';
import PremierPas from '../styles/images/drapeau-a-damier.png';

export const Niveaux = [
  { 
    id: 1, 
    niveau: "Premier Pas", 
    points: 0, 
    badge: PremierPas, 
    gains: [
      "Aucun"
    ] 
  },
  { 
    id: 2, 
    niveau: "Rookie", 
    points: 10000, 
    badge: debutant, 
    gains: [
      "1 Bon d'essence de 5€", 
      "-15% sur l'abonnement mensuel premium", 
      "-10% sur l'abonnement annuel"
    ] 
  },
  { 
    id: 3, 
    niveau: "Rider", 
    points: 20000, 
    badge: apprenti, 
    gains: [
      "1 Bon d'essence de 10€", 
      "-20% sur l'abonnement mensuel premium", 
      "-15% sur l'abonnement annuel"
    ] 
  },
  { 
    id: 4, 
    niveau: "Roadster", 
    points: 30000, 
    badge: amateur, 
    gains: [
      "2 Bons d'essence de 10€", 
      "-25% sur l'abonnement mensuel premium", 
      "-20% sur l'abonnement annuel"
    ] 
  },
  { 
    id: 5, 
    niveau: "Phantom", 
    points: 40000, 
    badge: confirme, 
    gains: [
      "3 Bons d'essence de 10€", 
      "-30% sur l'abonnement mensuel premium", 
      "-25% sur l'abonnement annuel", 
      "Accès VIP gratuit au salon de l'automobile de Paris"
    ] 
  },
  { 
    id: 6, 
    niveau: "Legend", 
    points: 50000, 
    badge: expert, 
    gains: [
      "4 Bons d'essence de 10€", 
      "-35% sur l'abonnement mensuel premium", 
      "-30% sur l'abonnement annuel", 
      "Stage de pilotage supercar sur circuit"
    ] 
  }
];


